
// Логотип на стр. авторизации
import logo from './logoAuthPage.svg'

// Фоновая картинка на стр. авторизации, стать клиентом
import bgAuth from './auth-bg.jpg'

// Ссылка у кнопки Веб-сайт Постачальника 
export const SITE_LINK = 'https://www.tes.trade'

// Название поставщика (ключ для перевода из файла локализации)
export const NAME_PROVIDER = 'ТОВ «Трейд Енерджі Солюшн»'
export const CRUMB_MAIN_TEXT = 'TES'

export { logo as AUTH_LOGO }
export { bgAuth as AUTH_BG_BODY }